import viMessages from '../locales/vi-vn.json';

const VnLang = {
	messages: {
		...viMessages
	},
	locale: 'vi-VN'
};
export default VnLang;
